import { createFileRoute } from "@tanstack/react-router";
import {
  runVerification,
  VerifyEmailView,
  type LoaderResult,
} from "./-verify-email-shared";

type Search = { token?: string };

export const Route = createFileRoute("/verify-email")({
  validateSearch: (s: Record<string, unknown>): Search => ({
    token: typeof s.token === "string" ? s.token : undefined,
  }),
  loaderDeps: ({ search }) => ({ token: search.token }),
  loader: ({ deps }): Promise<LoaderResult> => runVerification(deps.token),
  head: () => ({
    meta: [
      { title: "Confirm your email: CapitalDart" },
      { name: "robots", content: "noindex,nofollow" },
      { name: "referrer", content: "no-referrer" },
    ],
  }),
  component: VerifyEmailPage,
});

function VerifyEmailPage() {
  const result = Route.useLoaderData() as LoaderResult;
  return <VerifyEmailView result={result} />;
}
